module.exports = __webpack_public_path__ + "static/media/freepik__10-or-more-games-characters-in-gaming-world__94690.545f9471.png";